var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M491.32 235.32H20.68C9.26 235.32 0 244.58 0 256s9.26 20.68 20.68 20.68h470.64c11.42 0 20.68-9.26 20.68-20.68s-9.26-20.68-20.68-20.68zm0-156.88H20.68C9.26 78.44 0 87.7 0 99.12s9.26 20.68 20.68 20.68h470.64c11.42 0 20.68-9.26 20.68-20.68s-9.26-20.68-20.68-20.68zm0 313.76H20.68C9.26 392.2 0 401.46 0 412.88s9.26 20.68 20.68 20.68h470.64c11.42 0 20.68-9.26 20.68-20.68s-9.26-20.68-20.68-20.68z"}));
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
